import Header from './components/Header';
import Hero from './components/Hero';
import FeatureSection from './components/FeatureSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-800">
      <Header />
      <main>
        <Hero />
        <FeatureSection />
        <FAQSection />
        <AppSection />
        <CommentsSection />
        <UpdatesSection />
        <IndexSection />
        <RankingSection />
        <CarouselSection />
        <MediaSection />
        <CardsSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}